import React, { useEffect, useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useApp } from "../context/AppContext";
import { financeTipsEN, financeTipsES } from "../lib/financeTips";

const ROTATE_MS = 5 * 60 * 1000; // 5 minutes

const pickRandomIndex = (len, avoid) => {
    if (len <= 1) return 0;
    let i = Math.floor(Math.random() * len);
    if (i === avoid) i = (i + 1) % len;
    return i;
};

const TipsRotator = () => {
    const { language } = useApp();
    const tips = language === "es" ? financeTipsES : financeTipsEN;
    const [idx, setIdx] = useState(() => Math.floor(Math.random() * (tips.length || 1)));

    useEffect(() => {
        const id = setInterval(() => {
            setIdx((prev) => pickRandomIndex(tips.length, prev));
        }, ROTATE_MS);
        return () => clearInterval(id);
    }, [tips.length]);

    const tip = useMemo(() => tips[idx % tips.length], [tips, idx]);
    if (!tip) return null;

    return (
        <div className="mt-3 max-w-2xl" data-testid="dashboard-tips-rotator">
            <AnimatePresence mode="wait">
                <motion.div
                    key={language + idx}
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -6 }}
                    transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                >
                    <h3
                        className="font-display font-bold text-[hsl(var(--foreground))] text-lg md:text-xl tracking-tight"
                        data-testid="dashboard-tip-title"
                    >
                        {tip.title}
                    </h3>
                    <p
                        className="mt-1.5 text-[hsl(var(--muted-foreground))] leading-relaxed"
                        data-testid="dashboard-tip-body"
                    >
                        {tip.body}
                    </p>
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default TipsRotator;
